import { GenericMachine } from '_core/domain/Utils/Generic/Machines/GenericMachine';
import { isValidLogin } from '_core/helpers/validations';
import { IDocs } from '_core/types';
import { resetPasswordAccountIssueApi as API } from '../Apis';

export const ResetPasswordAccountIssueDocs: IDocs = {
  title: 'ResetPasswordAccountIssue',
  description: '',
  version: '0.0.1',
  apis: [
    {
      name: API.definitions.API_DOMAIN,
      path: API.definitions.ENDPOINT_API_PATH,
      linkPostman: API.definitions.URL_POSTMAN,
      order: 1,
    },
  ],
  codeToExecute: 'Services.AccountServices.resetPasswordAccountIssue',
};

const prepareCall = (stateRequestParameters: any) => {
  let request = {};
  const login = isValidLogin(stateRequestParameters.login);
  switch (login.type) {
    case 'EMAIL':
      request = {
        email: stateRequestParameters.login.toLowerCase(),
      };
      break;
    case 'CPF':
      request = {
        document: {
          type: 'CPF',
          value: stateRequestParameters.login,
        },
      };
      break;
    case 'MEMBER':
      request = {
        memberNumber: stateRequestParameters.login,
      };
      break;
    default:
      throw new Error('Tipo do Login inválido');
  }

  return API.call.post({
    ...request,
    formPage: {
      name: stateRequestParameters.formPage.name,
      document: stateRequestParameters.formPage.document,
      email: stateRequestParameters.formPage?.email,
      memberNumber: stateRequestParameters.formPage?.memberNumber,
      phoneList: [
        {
          type: 'CELLULAR',
          internationalCode: stateRequestParameters.formPage.cellPhone.DDI,
          areaCode: stateRequestParameters.formPage.cellPhone.DDD,
          number: stateRequestParameters.formPage.cellPhone.number,
        },
      ],
    },
  });
};

export const ResetPasswordAccountIssueMachine = GenericMachine(prepareCall, {
  docs: ResetPasswordAccountIssueDocs,
  definitions: API.definitions,
});
